<section class="container-fluid px-5 py-4">
    <header class="row pt-3">
        <div class="col-12 d-flex justify-content-between">
            <div>

                <ng-container *ngIf="!valideNegative(this.datos.pay_amount)">
                    <h4 class="text-white">Editar pago para el proyecto: {{title}}</h4>
                </ng-container>
                <ng-container *ngIf="valideNegative(this.datos.pay_amount)">
                    <h4 class="text-white">Editar descuento para el proyecto: {{title}}</h4>
              </ng-container>
                <h6 class="text-secondary"></h6>
            </div>
           
            <div class="d-flex justify-content-center align-items-center">
      
                <button
                  class="badge rounded-pill btn btn-outline-light"
                  [routerLink]="['/pdg/project/pay/list',idProject,title]"
                >
                  <i
                    class="fa-solid fa-right-from-bracket m-2 fs-6"
                    aria-hidden="true"
                  ></i>
                  <span class="m-2 fs-6">Volver al listado</span>
                </button>
    
              </div>
        </div>
    </header>

</section>
<div class="container px-5">
<section class="container-fluid shadow pt-3 pb-2 text-white backgroundTable mt-3 " style="min-height:750px !important;">
     <div class="container-fluid d-flex justify-content-between align-items-center">
        <div>
            <ng-container *ngIf="!valideNegative(this.datos.pay_amount)">
                <h5 class="ms-3">Editar pago.</h5>
            </ng-container>
            <ng-container *ngIf="valideNegative(this.datos.pay_amount)">
                <h5 class="ms-3">Editar descuento.</h5>
          </ng-container>

        </div>
    </div>
    <div class="componente-importantes text-start px-5">
        <div class="componente-importantes text-start px-5" style="min-height:700px;">
            <form action="" method="post" (submit)="formSubmit()" [formGroup]="createPayForm" class="row mx-5">

                <div class="form-group col-md-6 my-2">
                    <label for="formControlInput" class="form-label">Título:</label>
                    <input type="text" class="form-control custom-outline-input date" id="title"
                        formControlName="title">
                </div>
                <div class="form-group col-md-6 my-2">
                    <label for="formControlInput" class="form-label">Fecha Programada:</label>
                    <input readonly type="date" class="form-control custom-outline-input date" id="scheduled_date"
                        formControlName="scheduled_date">
                </div>

                <div class="form-group col-md-6 my-2">
                    <label for="formControlInput" class="form-label">Fecha Real:</label>
                    <input   readonly type="date" class="form-control custom-outline-input date" id="real_date"
                        formControlName="real_date">
                </div>
                <div class="form-group col-md-6 my-2">
                    <label for="formControlInput" class="form-label">Fecha Reprogramada:</label>
                    <input  readonly type="date" class="form-control custom-outline-input date" id="rescheduled_date"
                        formControlName="rescheduled_date">
                </div>

                <div class="form-group col-md-6 my-2">
                    <div>
                        <label for="formControlInput" class="form-label">Tipo de moneda</label>
                        <select  required class="custom-outline-input form-select"  (change)="actionSelectType()" formControlName="tipo_moneda" >
                        <option selected value="" > Seleccione...</option>
                        <option *ngFor="let item of listmonedas" [value]="item.id" >{{item.name}}</option>
                        </select>
                    </div>
                </div>
                <div class="form-group col-md-6 my-2">
                    <label for="formControlInput" class="form-label">Monto:</label>
                    <input type="text" class="form-control custom-outline-input date" id="pay_amount"
                        formControlName="pay_amount" (blur)="transformAmount($event, 1)" (keyup)="onKey()" >
                    <label *ngIf="this.active == true" for="formControlInput" class="form-label text-init">Cuando termine escribir el monto, presione click fuera de monto</label>
                </div>
              

            <ng-container *ngIf="permise == true">
                <div class="form-group col-md-6 my-2">
                    <label for="formControlInput" class="form-label">Monto Inicial:</label>
                    <input type="text" class="form-control custom-outline-input date" id="pay_init"
                        formControlName="pay_init" (blur)="transformAmount($event, 2)" (keyup)="onKeyInit()" >
                    <label *ngIf="this.active == true" for="formControlInput" class="form-label text-init">Cuando termine escribir el monto, presione click fuera de monto</label>
                </div>
            </ng-container>

            <ng-container *ngIf="permise == false">
                <div class="form-group col-md-6 my-2">
                    <label for="formControlInput" class="form-label">Monto Inicial:</label>
                    <span class="form-control custom-outline-input mt-3">{{ createPayForm.get('pay_init')?.value }}</span>
                </div>
            </ng-container>


                <ng-container *ngIf="this.datos != null">
                    <label for="formControlInput" class="form-label mt-5 text-center">{{this.datos.name}} {{pay_hes}}</label>
                </ng-container>

                <form [formGroup]="paymentsform" class="mt-2">

                    <div class="mt-2" formArrayName="items" *ngFor="let item of paymentsform.get('items')['controls']; let i = index;">
                        <div class="row" [formGroupName]="i">
                        <div class="col-3 ">
                            <div class="form-group mt-1">
                            <label for="formControlInput" class="form-label">Her:</label>
                            <input type="text" placeholder="HES" class="form-control custom-outline-input" formControlName="hes">
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="form-group mt-1">
                                <label for="formControlInput" class="form-label">Factura:</label>
                            <input type="text" placeholder="FACTURA" class="form-control custom-outline-input" formControlName="facture">
                            </div>
                        </div>
                      
                        <div class="col-4">
                        <div class="form-group mt-1">
                            <label for="formControlInput" class="form-label">Fecha factura:</label>
                            <input type="date" placeholder="FECHA FACTURA" class="form-control custom-outline-input date" id="facture_date"
                                formControlName="facture_date">
                        </div>
                        </div>

                        </div>
    
    
                    </div>
    
    
                    </form>
                <br>
                <div class="form-group d-flex justify-content-sm-end mt-4">
                    <div class="m-4">
                        <button  class="btn btn-outline-light me-3" style="font-size: 15px;" [disabled]="active"> <i _ngcontent-xfk-c127=""
                                class="fa-solid fa-floppy-disk m-2"></i> Guardar Cambios</button>
                    </div>
                    <br>




                </div>


            </form>


        </div>


    </div>

</section>
</div>

<router-outlet></router-outlet>